import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'venturesCount',
})
export class VenturesCountPipe implements PipeTransform {
  transform(attendee: any[]): any {
    return attendee.filter((obj) => {
      if (obj.role) {
        if (obj.role === 'V' && obj.is_staff) {
          return obj;
        }
      }
    });
  }
}
